const Enums = {
  statusCSSColors: {},
  pages: {
    DIAL_PAD: 'dialPad',
    QUICK_CONNECTS: 'quickConnects',
    SETTINGS: 'settings',
    ACTIVE_CALL: 'activeCall',
    AGENT_STATE_SELECT: 'agentStateSelect',
    HOME: 'home',
  },
  agentPhoneTypes: {
    DESK: 'desk',
    SOFT: 'soft',
  },
  creditCardCollectionTypes: {
    HOME_SERVICE: 'HomeService',
    HOME_WARRANTY: 'HomeWarranty',
  },
  stateNames: {
    ACW: 'After call work',
    AGENT_HOLD: 'Agent on hold',
    CONNECTED: 'Connected',
    CONNECTING: 'Connecting',
    DISCONNECTED: '<disconnected>',
    ERROR: 'Error',
    INBOUND: 'Inbound call',
    INCOMING: 'Incoming',
    INCOMING_CALLBACK: 'Callback incoming',
    INITIALIZATION_FAILURE: 'Initialization failed',
    INITIALIZING: 'Initializing...',
    JOINED: 'Joined',
    MISSED_CALL: 'Missed call',
    MONITORING: 'Monitoring',
    MUTED: 'MUTED',
    ON_HOLD: 'On hold',
    OUTBOUND: 'Outbound call',
  },
  callDirections: {
    INBOUND: 'inbound',
    OUTBOUND: 'outbound',
  },
  acceptedSymbols: [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '0',
  ],
  localStorageKeys: { // Local storage keys
    OUTBOUND_ISO_CODE: 'outboundISOCountryCode',
    OUTBOUND_DIAL_CODE: 'outboundCountryDialCode',
    HARDPHONE_ISO_CODE: 'hardphoneISOCountryCode',
    HARDPHONE_DIAL_CODE: 'hardphoneCountryDialCode',
    SHOW_HARDPHONE_CONFIG: 'showHardphoneConfig',
    HARDPHONE_RADIO_BUTTON_CHECKED: 'hardphoneRadioButtonChecked',
    SOFTPHONE_RADIO_BUTTON_CHECKED: 'softphoneRadioButtonChecked',
    CREDIT_CARD_DETAILS_CACHE: 'creditCardDetailsCache',
  },
  paymentDetailsEnum: { // Keys for CREDIT_CARD_DETAILS_CACHE
    DETAILS_LIST: 'ccList',
    CONTACT_ID: 'contactId',
    ORIGINAL_CONTACT_ID: 'originalContactId',
    CURRENT_TYPE: 'currentType',
    HW_TYPE: 'HomeWarranty',
    HS_TYPE: 'HomeServices',
    HW_COUNT: 'hwCount',
    HS_COUNT: 'hsCount',
    IS_WAITING: 'waitFlag',
    IS_HELD: 'holdFlag',
    IS_LOOKING: 'lookupFlag',
    IS_DROPPED: 'dropFlag',
    IS_DISPLAYED: 'displayFlag',
    EMPTY_MESSAGE: 'There Are No Payment Details Available',
    HELD_MESSAGE: 'The Caller Is Providing Payment Details',
    WAIT_MESSAGE: 'Please Wait While The Payment Details Are Processed',
    ERROR_MESSAGE: 'There Was An Error Collecting Payment Details',
    DROP_MESSAGE: 'The Caller Hung Up During Payment Details Collection',
    EXIT_MESSAGE: 'The Caller Exited The IVR Without Entering Payment Details',
  },
  loggerLevels: {
    WARNING: '[WARNING] :',
    INFO: '[INFO] :',
    ERROR: '[ERROR] :',
    FATAL: '[FATAL] :',
  },
  recordingDetailsEnum: {
    RECORDING_LABEL: 'Stop',
    SUSPENDED_LABEL: 'Start',
    RECORDING_MESSAGE: 'This call is currently being recorded',
    SUSPENDED_MESSAGE: 'Recording has been suspended for this call.',
    WAIT_SUSPEND_MESSAGE: 'Please wait while recording for this call is suspended.',
    WAIT_RESUME_MESSAGE: 'Please wait while recording for this call is resumed',
    ERROR_SUSPEND_MESSAGE: 'There was an error during the attempt to suspend recording. Please try again.',
    ERROR_RESUME_MESSAGE: 'There was an error during the attempt to resume recording. Please try again.',
    EMPTY_MESSAGE: 'There Is No Contact To Record At This Time.',
  },
};

export default Enums;
